export default "__VITE_ASSET__BDOqm9aI__"